module.exports = __webpack_public_path__ + "media/images/articles/entry_steps/thumb-1db9528e5175c954849e51da226e2b6b.png";